import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledBasicLabel = styled.div`
    display: flex;
    height: fit-content;
    ${setFontVariant("h4", colorsPalettes.carbon["400"])};

    font-weight: 400;
    white-space: nowrap;
    user-select: none;
`;
